import { get, merge } from 'lodash'
import { parseUrl, stringify } from 'query-string'

export default class EventModelClass {
  #type = ''
  #needCommonParams = false
  #needCredential = false
  #note = ''
  #url = ''
  #method = ''
  #hasDefaultParamsInUrl = false
  #offset = 0
  #limit = 20
  #isPaging = false
  #filter = null
  #uiCode = null
  #bodyList = []
  constructor(eventObj) {
    if (eventObj) {
      this.#type = get(eventObj, 'type', '')
      this.#note = get(eventObj, 'note', '')
      // this.#needCommonParams = get(eventObj, 'add_common_params', 'n') === 'y'
      // this.#needCredential = get(eventObj, 'add_credential', 'n') === 'y'
      this.#needCommonParams = true
      this.#needCredential = true
      const tmpUrl = get(eventObj, 'url', '')
      this.#url = tmpUrl.startsWith('http') ? tmpUrl : 'https://' + tmpUrl
      this.#method = get(eventObj, 'method', 'get')
      this.#hasDefaultParamsInUrl = tmpUrl.indexOf('?') > -1
      const { query } = parseUrl(this.#url)
      this.#uiCode = get(query, 'uitype', null)
      this.#bodyList = get(eventObj, 'bodylist', [])
    }
  }
  get type() {
    return this.#type
  }
  get needCommonParams() {
    return this.#needCommonParams
  }
  set needCommonParams(isNeed) {
    this.#needCommonParams = isNeed
  }
  get needCredential() {
    return this.#needCredential
  }
  set needCredential(isNeed) {
    this.#needCredential = isNeed
  }
  get url() {
    if (this.isDeepLink) {
      return this.#url.replace('captvpooq://', 'm.wavve.com/')
    } else {
      let { query, url } = parseUrl(this.#url)
      if (get(query, 'keyword', '') !== '') {
        query.keyword = encodeURIComponent(query.keyword)
      }
      if (this.#isPaging) {
        query.offset = this.#offset
        query.limit = this.#limit
      }
      if (this.hasFilter) {
        let filterQuery = this.#filter
        query = merge(query, filterQuery)
      }
      const orderKeys = Object.keys(query).reverse()
      return (
        url +
        '?' +
        stringify(query, {
          encode: false,
          sort: (a, b) => orderKeys.indexOf(a) - orderKeys.indexOf(b),
        })
      )
    }
  }
  set url(newUrl) {
    this.#url = newUrl
  }
  get method() {
    return this.#method
  }
  set method(method) {
    this.#method = method
  }
  get hasDefaultParamsInUrl() {
    return this.#hasDefaultParamsInUrl
  }
  get isDeepLink() {
    return this.#url.indexOf('captvpooq://') > -1
  }
  get offset() {
    return this.#offset
  }
  set offset(offset) {
    this.#offset = offset
  }
  get limit() {
    return this.#limit
  }
  set limit(limit) {
    this.#limit = limit
  }
  get isPaging() {
    return this.#isPaging
  }
  setPaging(bool) {
    this.#isPaging = bool
  }
  get filter() {
    return this.#filter
  }
  set filter(filterObj) {
    this.#filter = filterObj
  }
  get hasFilter() {
    return this.#filter !== null
  }
  get uiCode() {
    return this.#uiCode
  }
  get bodyList() {
    return this.#bodyList
  }
}
